import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = { class: "flex flex-lg-row flex-column result-buttons" }
const _hoisted_3 = { class: "result-buttons__button-group flex" }
const _hoisted_4 = {
  id: `result-print-link`,
  class: "button button-secondary",
  onclick: "window.print()"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row py-6" }
const _hoisted_8 = { class: "col-12 px-0" }
const _hoisted_9 = { class: "row py-6" }
const _hoisted_10 = { class: "col-12 px-0" }
const _hoisted_11 = { id: "description-section-main-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_ElectricityCalculator = _resolveComponent("ElectricityCalculator")!
  const _component_HeatCalculator = _resolveComponent("HeatCalculator")!
  const _component_FuelCalculator = _resolveComponent("FuelCalculator")!
  const _component_ProcessCalculator = _resolveComponent("ProcessCalculator")!
  const _component_CommonTransportCalculator = _resolveComponent("CommonTransportCalculator")!
  const _component_ResultsESG = _resolveComponent("ResultsESG")!
  const _component_AccordionComponent = _resolveComponent("AccordionComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { basisModule: true }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "basismodule.overview.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "basismodule.overview.header-text" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        (_ctx.simpleTextOrNull('home.header.button2.link'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-cy": _ctx.simpleTextOrNull('home.header.button2.link'),
              type: "button",
              class: "button button-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.simpleTextOrNull('home.header.button2.link'))))
            }, [
              _createVNode(_component_SimpleText, { "text-key": "home.header.button2.text" })
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_SimpleText, { "text-key": "results.printButtonText" })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ElectricityCalculator, {
            subgroupingId: _ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET,
            title: _ctx.getContentfulString('subcategories.subgroupelectricity'),
            tooltip: _ctx.getContentfulString('basis-module.electricity.tooltip'),
            expanded: true,
            basisModule: true,
            onSaveCalculationLine: _ctx.saveCalculationLine,
            onDeleteCalculationLine: _ctx.deleteCalculationLine
          }, null, 8, ["subgroupingId", "title", "tooltip", "onSaveCalculationLine", "onDeleteCalculationLine"]),
          _createVNode(_component_HeatCalculator, {
            subgroupingId: _ctx.constants.GROUP_FJERNVARME,
            title: _ctx.getContentfulString('subcategories.subgroup-heat'),
            tooltip: _ctx.getContentfulString('basis-module.heat.tooltip'),
            expanded: false,
            basisModule: true,
            onSaveCalculationLine: _ctx.saveCalculationLine,
            onDeleteCalculationLine: _ctx.deleteCalculationLine
          }, null, 8, ["subgroupingId", "title", "tooltip", "onSaveCalculationLine", "onDeleteCalculationLine"]),
          _createVNode(_component_FuelCalculator, {
            subgroupingId: _ctx.constants.GROUP_BRÆNDSLER,
            title: _ctx.getContentfulString('subcategories.subgroup-fuel'),
            tooltip: _ctx.getContentfulString('basis-module.fuel.tooltip'),
            expanded: false,
            basisModule: true,
            onSaveCalculationLine: _ctx.saveCalculationLine,
            onDeleteCalculationLine: _ctx.deleteCalculationLine
          }, null, 8, ["subgroupingId", "title", "tooltip", "onSaveCalculationLine", "onDeleteCalculationLine"]),
          _createVNode(_component_ProcessCalculator, {
            subgroupingId: _ctx.constants.GROUP_PROCESUDLEDNING,
            title: _ctx.getContentfulString('subcategories.subgroup-process'),
            tooltip: _ctx.getContentfulString('basis-module.process.tooltip'),
            expanded: false,
            basisModule: true,
            onSaveCalculationLine: _ctx.saveCalculationLine,
            onDeleteCalculationLine: _ctx.deleteCalculationLine
          }, null, 8, ["subgroupingId", "title", "tooltip", "onSaveCalculationLine", "onDeleteCalculationLine"]),
          _createVNode(_component_CommonTransportCalculator, {
            subgroupingId: _ctx.constants.GROUP_EGNE_OG_LEASEDE_KØRETØJER,
            title: _ctx.getContentfulString('group.text.category.groupownleasedtransports'),
            tooltip: _ctx.getContentfulString('basis-module.leasedtransports.tooltip'),
            expanded: false,
            basisModule: true,
            onSaveCalculationLine: _ctx.saveCalculationLine,
            onDeleteCalculationLine: _ctx.deleteCalculationLine
          }, null, 8, ["subgroupingId", "title", "tooltip", "onSaveCalculationLine", "onDeleteCalculationLine"]),
          (_ctx.results.esgResult && this.anonymousCalculationLines.length > 0)
            ? (_openBlock(), _createBlock(_component_ResultsESG, {
                key: 0,
                results: _ctx.results,
                basisModule: true
              }, null, 8, ["results"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, [
            (!_ctx.basisModule)
              ? (_openBlock(), _createBlock(_component_SimpleText, {
                  key: 0,
                  "text-key": "basis-module.description.header"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_AccordionComponent, {
            "accordion-list": _ctx.getAccordions("basis-module"),
            "unique-id": _ctx.getUniqueId()
          }, null, 8, ["accordion-list", "unique-id"])
        ])
      ])
    ])
  ], 64))
}